import React, { useEffect } from "react";
import Services from "../components/sections/Services";
import Capabilities from "../components/sections/Capabilities";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../hooks/useSEO";
import { useLang } from "../context/LanguageContext";

export default function ServicesPage() {
  const { lang } = useLang();
  useSEO({
    title: lang === "pl" ? "Usługi — LK LOG" : "Services — LK LOG",
    description:
      lang === "pl"
        ? "Transport i spedycja, logistyka operacyjna, doradztwo ADR/DGSA i wsparcie prawne Solutio. 41 zestawów 13,6 m, 11 busów 8/10 EP."
        : "Transport and forwarding, operational logistics, ADR/DGSA consulting and Solutio legal support. 41 x 13.6m combinations, 11 vans 8/10 EP.",
    path: "/uslugi",
    lang,
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <main data-testid="services-page" className="pt-20">
      <Services />
      <Capabilities />
      <FinalCTA />
    </main>
  );
}
